import { ianaTimeZonesBase } from '../lib';
import { getRandomElementFromArray } from '../../../../../utils';

export function generateRandomIanaTimeZone(): string {
    return getRandomElementFromArray(ianaTimeZonesBase);
}
